import React from 'react';
import UpgradeRequiredTooltipWrapper from "../../utils/billing/UpgradeRequiredTooltipWrapper";

interface LomavisButtonToggle1Props {
    buttonLeftFaIconClass?: string;
    buttonLeftText?: string;
    buttonLeftValue?: any;
    buttonLeftShowUpgrade?: boolean;
    hideLeftButton?: boolean;

    buttonRightFaIconClass?: string;
    buttonRightText?: string;
    buttonRightValue?: any;
    buttonRightShowUpgrade?: boolean;
    hideRightButton?: boolean;

    value: any;
    onChange: (value: any) => void;
}

interface ButtonProps {
    faIconClass?: string;
    text: string;
    value: any;
    isActive: boolean;
    onClick: () => void;
    showUpgrade?: boolean;
}

const Button: React.FC<ButtonProps> = ({
                                           faIconClass,
                                           text,
                                           value,
                                           isActive,
                                           onClick,
                                           showUpgrade
                                       }) => (
    <UpgradeRequiredTooltipWrapper show={showUpgrade}>
        <button
            type="button"
            className={`btn d-flex align-items-center fw-bold rounded btn-sm ${
                isActive ? 'bg-light-primary text-primary' : 'bg-white text-dark'
            }`}
            onClick={onClick}
        >
            {faIconClass && (
                <i
                    className={`${faIconClass} me-2 fs-1 ${
                        isActive ? 'text-primary' : 'text-secondary'
                    }`}
                ></i>
            )}
            <span className="flex-grow-1 text-center fs-6">{text}</span>
        </button>
    </UpgradeRequiredTooltipWrapper>
);

const LomavisButtonToggle1: React.FC<LomavisButtonToggle1Props> = ({
                                                                       buttonLeftFaIconClass,
                                                                       buttonLeftText = '',
                                                                       buttonLeftValue,
                                                                       buttonLeftShowUpgrade = false,
                                                                       hideLeftButton = false,

                                                                       buttonRightFaIconClass,
                                                                       buttonRightText = '',
                                                                       buttonRightValue,
                                                                       buttonRightShowUpgrade = false,
                                                                       hideRightButton = false,

                                                                       value,
                                                                       onChange
                                                                   }) => {
    const isLeftActive = value === buttonLeftValue;
    const isRightActive = value === buttonRightValue;

    const handleLeftClick = (): void => {
        if (buttonLeftShowUpgrade) return;
        if (!isLeftActive) onChange(buttonLeftValue);
    };

    const handleRightClick = (): void => {
        if (buttonRightShowUpgrade) return;
        if (!isRightActive) onChange(buttonRightValue);
    };

    return (
        <div className="border rounded p-1 border-secondary">
            <div className="btn-group w-100 gap-2" role="group">
                {!hideLeftButton && (
                    <Button
                        faIconClass={buttonLeftFaIconClass}
                        text={buttonLeftText}
                        value={buttonLeftValue}
                        isActive={isLeftActive}
                        onClick={handleLeftClick}
                        showUpgrade={buttonLeftShowUpgrade}
                    />
                )}
                {!hideRightButton && (
                    <Button
                        faIconClass={buttonRightFaIconClass}
                        text={buttonRightText}
                        value={buttonRightValue}
                        isActive={isRightActive}
                        onClick={handleRightClick}
                        showUpgrade={buttonRightShowUpgrade}
                    />
                )}
            </div>
        </div>
    );
};

export default LomavisButtonToggle1;
